export { default as BrandingIdentity } from './identity'
export type { Props as BrandingIdentityProps } from './identity'
